import available from '../columns/available';
import { connectionNameColumn } from '../columns/connection-name';
import connectionSku from '../columns/connection-sku';
import productName from '../columns/productName';
import sku from '../columns/sku';

export const externalInventoryColumns = {
  available,
  connectionSku,
  productName,
  sku,
};

export const aggregatedExternalInventoryColumns = {
  available,
  connectionSku,
  connectionName: connectionNameColumn,
  productName,
  sku,
};
